// extracted by mini-css-extract-plugin
export default {"buttonSemRotulo":"ExemploBaseFilter_buttonSemRotulo__1XDvI","dFlex":"ExemploBaseFilter_dFlex__ya5II"};